import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ASSETS_HOST: process.env.VUE_APP_ASSETS_HOST,
    API_HOST: process.env.VUE_APP_API_HOST,
    favouritesString: new URL(location.href).searchParams.get('p'),
    sectorsString: new URL(location.href).searchParams.get('s'),
    isLeadFormTimeoutFinished: false,
    isLoading: true,
    isReturningUser: new URL(location.href).searchParams.get('r') === '1',
    message: new URL(location.href).searchParams.get('m'),
    properties: [],
    livingOptions: [],
  },

  getters: {
    favouritePropertyIds (state) {
      return state.favouritesString ? state.favouritesString.split(',') : []
    },

    favouriteSectorIds (state) {
      return state.sectorsString ? state.sectorsString.split(',') : []
    },

    favouriteProperties (state, getters) {
      const unsortedFavouriteProperties = state.properties.filter(property => {
        return getters.favouritePropertyIds.includes(property._id)
      })
      const sortedFavouriteProperties = getters.favouritePropertyIds.map(propertyId => {
        return unsortedFavouriteProperties.find(property => property._id.toString() === propertyId)
      })
      return sortedFavouriteProperties
    },

    favouriteSectors (state, getters) {
      const unsortedFavouriteSectors = state.livingOptions.filter(sector => {
        return getters.favouriteSectorIds.includes(sector._id)
      })
      const sortedFavouriteSectors = getters.favouriteSectorIds.map(sectorId => {
        return unsortedFavouriteSectors.find(sector => sector._id.toString() === sectorId)
      })
      return sortedFavouriteSectors
    }, 

    isValidFavourites (state, getters) {
      return Boolean(getters.favouriteProperties.length || getters.favouriteSectors.length)
    },

    isLeadFormTimeoutFinished: state => state.isLeadFormTimeoutFinished,

    isLoading: state => state.isLoading,

    isReturningUser: state => state.isReturningUser,

    message: state => state.message,

    structuredPropertyData (state, getters) {
      let structuredPropertyData = []
      if (getters.isValidFavourites) {
        getters.favouriteSectors.forEach(sector => {
          let livingOption = structuredPropertyData.find(livingOption => livingOption._id === sector._id)
          if (!livingOption) {
            livingOption = state.livingOptions.find(livingOption => livingOption._id === sector._id)
            if (livingOption) structuredPropertyData.push(livingOption)
          }
          if (livingOption) {
            livingOption.properties = livingOption.properties || []
          }
        })
        getters.favouriteProperties.forEach(property => {
          let livingOption = structuredPropertyData.find(livingOption => livingOption._id === property.livingOption.id)
          if (!livingOption) {
            livingOption = state.livingOptions.find(livingOption => livingOption._id === property.livingOption.id)
            if (livingOption) structuredPropertyData.push(livingOption)
          }
          if (livingOption) {
            livingOption.properties = livingOption.properties || []
            livingOption.properties.push(property)
          }
        })
      }
      return structuredPropertyData
    },
  },

  mutations: {
    SET_PROPERTIES (state, { properties, livingOptions}) {
      state.properties = properties
      state.livingOptions = livingOptions
    },

    LEADFORM_TIMEOUT_FINISHED (state) {
      state.isLeadFormTimeoutFinished = true
    }
  },

  actions: {
    async fetchData ({ state, commit }) {
      state.isLoading = true
      Promise.all([
        axios.get(state.API_HOST + 'living/properties/structured/all'),
        axios.get(state.API_HOST + 'living/living-options'),
      ]).then(res => {
        commit('SET_PROPERTIES', { properties: res[0].data, livingOptions: res[1].data })
      }).finally(() => {
        state.isLoading = false
      })
    },
  },
})
